import { useState } from "react";

import classes from "./DropDownMenu.module.css";

// hook for menu drop down
const useDropdownMenu = (options) => {
  const [showDropdown, setShowDropdown] = useState(false); // expand drop down options
  const [selectedOption, setSelectedOption] = useState("Select"); // chosen drop down value
  const [isValid, setIsValid] = useState(false); // whether selection is valid

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    toggleDropdown();
    setIsValid(true);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const DropdownMenu = () => (
    <div className={classes.dropdown}>
      <div className={classes.dropdown_toggle_button} onClick={toggleDropdown}>
        {selectedOption}
      </div>
      {showDropdown && (
        <div className={classes.dropdown_menu}>
          {options.map((option) => (
            <div key={option} className={classes.dropdown_menu_item }onClick={() => handleOptionSelect(option)}>
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );

  return { DropdownMenu, selectedOption, isValid };
};

export default useDropdownMenu;
